import type { DischargeReasonTransformerType } from "@/Modules/Transformers/DischargeReason";
import * as Sentry from "@sentry/vue";

import ReasonApiToReasonTransformer from "@/Modules/Transformers/DischargeReason";

import DischargeApiConnector from "@/Services/TherapyApi/Discharge";
import { log } from "@/Utils/Debug";

import { hasValue } from "@/Utils/Objects";

async function fetchDischargeReasonsAH() {
  const dischargeApi = new DischargeApiConnector();
  const reasonApiToReasonTransformer: DischargeReasonTransformerType = ReasonApiToReasonTransformer;

  try {
    const reasons = await dischargeApi.getReasons();

    if (hasValue(reasons)) {
      return reasons.map(reasonApiToReasonTransformer.toDomain);
    }
  } catch (error) {
    log(error);
    Sentry.captureException(error);

    return [];
  }
}

export default fetchDischargeReasonsAH;
